import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LocalStorageService } from 'src/app/services/shared/local-storage/local-storage.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { SessionService } from 'src/app/services/shared/session/session.service';
import { SharedService } from 'src/app/services/shared/shared.service';
import { ContributionService } from 'src/app/services/shared/contribution/contribution.service';
import { jwtDecode } from 'jwt-decode';

@Component({
  selector: 'app-externo-token-oidc',
  templateUrl: './externo-token-oidc.component.html',
  standalone: false
})

export class ExternoTokenOidcComponent implements OnInit {
  codeParam: string;
  codeParamDecodeJson: JSON;

  oidcGeos: string;
  oidcSuppliers: string[];
  oidcIdToken: string;
  oidcIdTokenDecodeJson: JSON;

  oidcIdTokenIssuer: string;
  oidcIdTokenClientId: string;

  oidcToken: any;

  oidcEmail: string;
  oidcName: string;
  configInit: any;
  universalSupplier: any;

  constructor(
    private route: ActivatedRoute,
    private localStorageService: LocalStorageService,
    private router: Router,
    private sessionService: SessionService,
    private sharedService: SharedService,
    private contributionService: ContributionService
  ) {
    localStorage.setItem("okt", "true");
  }

  ngOnInit(): void {
    this.externoToken();
  }

  externoToken() {
    const origin = window.document.referrer;
    this.localStorageService.setIsVip = true;
    this.route.queryParams.subscribe(params => {
      this.inicializaParamsOidc(params);
      this.localStorageService.setMatrizArray = this.oidcSuppliers;
      this.emuTokenPingId();
      this.tokenExpiration();

      // Sincronizar el access token recibido del externo a localStorage
      const rawAccessToken = this.oidcToken?.['accessToken'];
      if (typeof rawAccessToken === 'string') {
        localStorage.setItem('access_token', rawAccessToken);
      } else if (rawAccessToken && typeof rawAccessToken === 'object') {
        localStorage.setItem('access_token', rawAccessToken['accessToken'] || '');
      }

      // Guardar refresh_token OIDC si viene disponible en cualquier variante del payload externo
      const refreshToken = this.extractOidcRefreshToken(params);
      if (refreshToken) {
        // Compatibilidad con payload Portal: refresh_token (snake_case)
        localStorage.setItem('refresh_token', refreshToken);
        localStorage.setItem('oidc_refresh_token', refreshToken);
        console.log('[ExternoTokenOidc] refresh_token OIDC detectado y persistido para renovación interna. Longitud:', refreshToken.length);
      } else {
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('oidc_refresh_token');
        const codeKeys = this.codeParamDecodeJson ? Object.keys(this.codeParamDecodeJson as any) : [];
        const oktaTokenKeys = this.oidcToken ? Object.keys(this.oidcToken as any) : [];
        console.warn('[ExternoTokenOidc] payload OIDC sin refresh_token: el renew interno dependerá de redirect a Commerce-CIAM');
        console.warn('[ExternoTokenOidc] Diagnóstico payload (sin secretos) -> code keys:', codeKeys, '| oktaToken keys:', oktaTokenKeys, '| query has refresh_token:', !!params?.['refresh_token'], '| query has refreshToken:', !!params?.['refreshToken']);
      }

      this.getInitConfigVip();
    });
  }

  private extractOidcRefreshToken(params: any): string | null {
    const candidates: any[] = [
      params?.['refresh_token'],
      params?.['refreshToken'],
      this.codeParamDecodeJson?.['refresh_token'],
      this.codeParamDecodeJson?.['refreshToken'],
      this.codeParamDecodeJson?.['oktaToken']?.['refresh_token'],
      this.codeParamDecodeJson?.['oktaToken']?.['refreshToken'],
      this.codeParamDecodeJson?.['oktaToken']?.['token']?.['refresh_token'],
      this.codeParamDecodeJson?.['oktaToken']?.['token']?.['refreshToken'],
      this.codeParamDecodeJson?.['oktaToken']?.['tokenObj']?.['refresh_token'],
      this.oidcToken?.['refresh_token'],
      this.oidcToken?.['refreshToken'],
      this.oidcToken?.['token']?.['refresh_token'],
      this.oidcToken?.['token']?.['refreshToken'],
      this.oidcToken?.['tokenObj']?.['refresh_token'],
    ];

    const firstValid = candidates.find((item) => typeof item === 'string' && item.trim().length > 0);
    return firstValid || null;
  }

  inicializaParamsOidc(params: any) {
    this.codeParam = params['code'];
    // El 'code' es un JSON en Base64, NO es un JWT (no tiene 3 partes separadas por punto)
    this.codeParamDecodeJson = JSON.parse(atob(this.codeParam));

    this.oidcGeos = this.codeParamDecodeJson['geos'];

    this.localStorageService.setCountryString = this.oidcGeos;
    this.oidcSuppliers = this.codeParamDecodeJson['suppliers'];
    this.oidcToken = this.codeParamDecodeJson['oktaToken'];
    // init agregado de universalSupplier
    this.universalSupplier = this.codeParamDecodeJson['universalSupplier'];
    if (this.universalSupplier && this.universalSupplier !== 'null') {
      this.localStorageService.universalSupplier = this.universalSupplier || '';
    } else {
      this.universalSupplier = null;
    }
    // end de universalSupplier
    this.oidcToken = this.codeParamDecodeJson['oktaToken'];

    // Compatibilidad con formato nuevo (OIDC) y antiguo (Oidc SDK):
    // Formato nuevo: oidcToken = { accessToken: "jwt...", idToken: "jwt..." }
    // Formato antiguo: oidcToken = { idToken: { idToken: "jwt...", issuer: "...", clientId: "..." }, accessToken: { accessToken: "jwt..." } }
    const rawIdToken = this.oidcToken['idToken'];
    if (typeof rawIdToken === 'string') {
      // Formato nuevo: idToken es directamente el JWT string
      this.oidcIdToken = rawIdToken;
    } else if (rawIdToken && typeof rawIdToken === 'object') {
      // Formato antiguo: idToken es un objeto con .idToken adentro
      this.oidcIdToken = rawIdToken['idToken'];
    }

    // Extraer issuer y clientId del JWT decodificado si están disponibles
    let decodedIdToken: any = null;
    if (this.oidcIdToken) {
      try {
        decodedIdToken = jwtDecode(this.oidcIdToken);
      } catch (e) {
        console.warn('[ExternoTokenOidc] No se pudo decodificar idToken:', e);
      }
    }

    // Obtener issuer y clientId: primero del formato antiguo, luego del JWT decodificado
    this.oidcIdTokenIssuer = (typeof rawIdToken === 'object' ? rawIdToken?.['issuer'] : null)
      || decodedIdToken?.['iss'] || '';
    this.oidcIdTokenClientId = (typeof rawIdToken === 'object' ? rawIdToken?.['clientId'] : null)
      || decodedIdToken?.['aud'] || decodedIdToken?.['client_id'] || '';

    // Extraer claims para obtener nombre y email
    // Prioridad: 1) campo userData del payload (formato nuevo OIDC), 2) claims del idToken decodificado
    const userDataRaw = this.codeParamDecodeJson['userData'];
    let userDataJson: any = null;
    if (userDataRaw) {
      try {
        userDataJson = typeof userDataRaw === 'string' ? JSON.parse(userDataRaw) : userDataRaw;
      } catch (e) {
        console.warn('[ExternoTokenOidc] No se pudo parsear userData:', e);
      }
    }

    // Construir claims combinando userData (prioridad) con idToken decodificado (fallback)
    this.oidcIdTokenDecodeJson = userDataJson || decodedIdToken || {} as any;

    // Compatibilidad: asegurar que oidcToken tenga el formato esperado por emuTokenPingId
    // Normalizar a formato antiguo para que oidc-token-storage sea consistente
    const rawAccessToken = this.oidcToken['accessToken'];
    if (typeof rawAccessToken === 'string') {
      this.oidcToken['accessToken'] = {
        accessToken: rawAccessToken
      };
    }

    if (typeof rawIdToken === 'string') {
      this.oidcToken['idToken'] = {
        idToken: this.oidcIdToken,
        issuer: this.oidcIdTokenIssuer,
        clientId: this.oidcIdTokenClientId,
        claims: this.oidcIdTokenDecodeJson
      };
    } else {
      this.oidcToken['idToken']['claims'] = this.oidcIdTokenDecodeJson;
    }

    // Extraer nombre y email desde userData o idToken claims
    this.oidcName = userDataJson?.['given_name']
      ? (userDataJson['given_name'] + ' ' + (userDataJson['family_name'] || '')).trim()
      : (this.oidcIdTokenDecodeJson['name'] || '');
    this.oidcEmail = userDataJson?.['email'] || this.oidcIdTokenDecodeJson['email'] || '';
  }

  emuTokenPingId() {
    let emuTokenPingIdJson = {
      "sub": this.oidcEmail,
      "aud": "",
      "jti": "",
      "iss": "", // https://fedssoqa.equifax.com
      "iat": 0,
      "exp": 0,
      "acr": "",
      "auth_time": 0,
      "firstName": this.oidcName,
      "lastName": "",
      "mail": this.oidcEmail,
      "groups": [
        "CN=" + this.oidcGeos.toLowerCase() + "-vip_npe_admin,OU=vip,OU=vip,OU=vip,DC=vip,DC=vip,DC=vip", // -datamaintenance_npe_admin,OU=datafabric,OU=appgroups,OU=accessmgmnt,DC=eis,DC=equifax,DC=com
        "CN=" + this.oidcGeos.toLowerCase() + "-vip_uat_admin,OU=vip,OU=vip,OU=vip,DC=vip,DC=vip,DC=vip",
        "CN=" + this.oidcGeos.toLowerCase() + "-vip_prd_admin,OU=vip,OU=vip,OU=vip,DC=vip,DC=vip,DC=vip"
      ],
      "pi.sri": "",
      "s_hash": ""
    };

    let emuPingIdIdToken = "eyJhbGciOiJSUzI1NiIsImtpZCI6IiJ9." + btoa(JSON.stringify(emuTokenPingIdJson)) + ".JE5Q";
    let emuPingIdTokenObj = { access_token: "", expires_in: 99999, id_token: emuPingIdIdToken, refresh_token: "", scope: "", token_type: "" };
    localStorage.setItem('idToken', emuPingIdIdToken);
    localStorage.setItem('tokenObj', JSON.stringify(emuPingIdTokenObj));
    localStorage.setItem('idTokenOidc', this.oidcIdToken);

    localStorage.setItem('loginStatus', 'Ok');
    localStorage.setItem('urlReturn', environment.URL_RETURN_APP_VIP);
    localStorage.setItem('suppliers', JSON.stringify(this.oidcSuppliers));
    localStorage.setItem('oidc-token-storage', JSON.stringify(this.oidcToken));

    localStorage.setItem('oidc-idtoken-issuer', this.oidcIdTokenIssuer);
    localStorage.setItem('oidc-idToken-clientid', this.oidcIdTokenClientId);
  }

  tokenExpiration() {
    try {
      // Leer la expiración real del access token JWT
      const rawAccessToken = this.oidcToken?.['accessToken'];
      const accessToken = typeof rawAccessToken === 'string'
        ? rawAccessToken
        : rawAccessToken?.accessToken;

      if (accessToken) {
        const decoded: any = jwtDecode(accessToken);
        if (decoded?.exp) {
          const expirationDate = new Date(decoded.exp * 1000);
          localStorage.setItem('token_expiration', expirationDate.toISOString());
          console.log('Token OIDC expira en:', expirationDate.toLocaleString());
          return;
        }
      }
    } catch (e) {
      console.warn('No se pudo leer exp del access token OIDC, usando fallback:', e);
    }

    // Fallback: 2 horas desde ahora
    const expirationDate = new Date();
    const duracionToken = new Date(expirationDate.getTime() + 2 * 60 * 60 * 1000);
    localStorage.setItem('token_expiration', duracionToken.toISOString());
  }

  redirectFailedOidc() {
    const commerceUrl = this.configInit?.["F_OKTA_COMMERCE_URL"] || environment.OKTA_COMMERCE_URL;
    if (this.oidcGeos === null || this.oidcSuppliers === null || this.oidcToken === null || this.oidcIdToken === null || this.oidcEmail === null) {
      console.warn('[ExternoTokenOidc] Parámetros Oidc incompletos');
      console.warn('[ExternoTokenOidc] Redirect fail -> Commerce-CIAM:', commerceUrl);
      window.location.href = commerceUrl;
    }
    if (Object.keys(this.oidcToken).length === 0) {
      console.warn('[ExternoTokenOidc] Token OIDC vacío, redirect fail -> Commerce-CIAM:', commerceUrl);
      window.location.href = commerceUrl;
    }
  }

  getInformationUniversalSupliers() {
    this.contributionService.generateSessionContribution().subscribe({
      next: (response: any) => {
        const token = response['access_token'];
        localStorage.setItem('tokenAPIGEE', token);

        const universalSupplier = this.localStorageService.universalSupplier;
        this.contributionService.getSuplierInformation(universalSupplier, this.oidcGeos).subscribe({
          next: (responseInformation: any) => {
            if (responseInformation.hasOwnProperty('t1')) {
              this.localStorageService.supliersInformation = responseInformation;
              const t1 = responseInformation.t1;
              const supliers: string[] = [];
              if (t1.hasOwnProperty('supplierServant') && t1.supplierServant.length > 0) {
                t1.supplierServant.forEach((suplier: any) => {
                  supliers.push(suplier["suppliercode"]);
                })
              }
              if (t1.hasOwnProperty('codAfiliado') && t1.codAfiliado !== null) {
                supliers.push(t1.codAfiliado);
              }
              if (t1.hasOwnProperty('supplierCode') && t1.supplierCode !== null && t1.codAfiliado === null) {
                supliers.push(t1.supplierCode);
              }
              localStorage.setItem('matrizArray', JSON.stringify(supliers));
              this.localStorageService.setMatrizArray = supliers;
            }
          },
        })
      }
    });
  }

  getInitConfigVip() {
    this.sharedService.getConfigInitVip().subscribe({
      next: (response) => {
        this.localStorageService.configInit = response;
        this.configInit = response;
        this.localStorageService.setNiveles = response['F_PERMISSION_ALL_ROLES'];

        // Arrancar monitor de sesión una vez que token + configInit ya están listos.
        this.sessionService.startSession();

        if (this.universalSupplier) {
          this.getInformationUniversalSupliers();
        }

        // Si existe una URL de retorno (re-autenticación), redirigir ahí en vez del home
        const returnUrl = localStorage.getItem('oidc-return-url');
        if (returnUrl) {
          localStorage.removeItem('oidc-return-url');
          this.router.navigateByUrl(returnUrl);
        } else {
          this.router.navigate([environment.URL_RETURN_APP_VIP]);
        }

        this.redirectFailedOidc();
      }
    })
  }

}
